export default {
    data: () => ({
        is_mobile: window.innerWidth < 577,
        is_tablet: window.innerWidth > 576 && window.innerWidth < 769
    }),
    computed: {
        is_large_screen() {
            return !this.is_mobile && !this.is_tablet
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.is_mobile = window.innerWidth < 577;
                this.is_tablet = window.innerWidth > 576 && window.innerWidth < 769;
            });
        })
    }
}
